import { useState } from "react";
import { Link } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import NavDrawer from "./NavDrawer";
import { BasicSelect as TransLang } from "./TransLang"
import './Nav.css'
import i18next from "i18next";
import theme from "../../util/theme";
import { Pages } from "../../constants";
import logo from './../../assets/Logo/logo1.png'




function NavBar() {

    let lng = i18next.language
    const [drawer, setDrawer] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    return (
        <>
            <Box sx={{ backgroundColor: theme.palette.background.default, py:4 }} >
                <AppBar position="static" elevation={0} className="appNav">
                    <Toolbar disableGutters>
                        <Box
                            sx={{
                                flexGrow: 1,
                                marginInlineStart: 1,
                                display: { md: "flex", xs: "none" },
                                alignItems: "center",
                                justifyContent: 'space-evenly',
                            }}>
                            <Link
                                to="/"
                                style={{
                                    textDecoration: "none",
                                    marginInlineStart: 8,
                                    width: '50px',
                                    height: '50px'
                                }}>
                                <img src={logo} alt="logo" className="nav-logo" width={'100%'}/>
                            </Link>
                            {Pages?.map((page, i) => (
                                <Link
                                    key={i}

                                    to={page.path}
                                    style={{ textTransform: 'capitalize', }}
                                    className="link"
                                    onClick={() => scrollToTop()}>
                                    {lng === 'ar' ? page.name : page.name_en}
                                </Link>
                            ))}
                            <TransLang />
                        </Box>
                        <Box sx={{ justifyContent: 'space-between', display: 'flex', gap: { md: '65px', xs: 1 }, width: { md: 'fit-content', xs: '100%' }, alignItems: 'center' }} > 
                            <Box
                                sx={{
                                    flexGrow: 0,
                                    display: { md: "none", xs: "flex" },
                                    justifyContent: "space-between",
                                    width: "100%",
                                    alignItems: 'center'
                                }}>
                                <Link
                                    to="/"
                                    style={{
                                        textDecoration: "none",
                                        marginInlineStart: 8,
                                        width:'60px',
                                        height:'60px'
                                    }}>
                                    <img src={logo} alt="logo" className="nav-logo" style={{ width: '100%', }} ></img>
                                </Link>
                                <IconButton onClick={() => setDrawer(true)}>
                                    <MenuIcon sx={{ fontSize: '2rem', color: theme.palette.primary.main }} />
                                </IconButton>
                            </Box>
                        </Box>
                    </Toolbar>
                </AppBar>
            </Box>
            <NavDrawer drawer={drawer} setDrawer={setDrawer} />
        </>
    );
}
export default NavBar;
